import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import '../../../styles/main.css';
import { StoreSettSecUser } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import CxChooser from '../../cx/CxChooser';
import CxState from '../../cx/CxState';
import CxAccordion from '../../cx/CxAccordion';
import { useAccess } from '../../hx/useAccess';


const MxSettSecUserForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.security'));

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [isMaster, setIsMaster] = React.useState(false);

  let r_form = React.useRef(null);

  let rf_txUser = React.useRef(null);
  let rf_txSecGroup = React.useRef(null);
  let rf_txBranchForced = React.useRef(null);
  let rf_boShowUserDataOnly = React.useRef(null);

  const r_snack_error = React.useRef(null);
  let r_error_message = React.useRef(null);

  const [storeSettSecUser, setStoreSettSecUser] = useSessionStorage('StoreSettSecUser', StoreSettSecUser);


  const formLoad = async (data) => {
    FxLog.infox('MxSettSecUserForm.formLoad', '...data:', data);
    if (data === null) { //nuevo registro
    } else { // registro existente
      setIsMaster(Boolean(rf_txUser.current.getVal() === 'master'));
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus === 'error') {
      if (lastSaveRv.theValue.startsWith("rv_")) {
        // errores al guardar
        if (lastSaveRv.theValue.startsWith("rv_name_exists")) {
          r_snack_error.current.setVal(trans('msg.existing_x','field.name'));
        }
        if (lastSaveRv.theValue.startsWith("rv_not_an_email")) {
          r_snack_error.current.setVal(trans('msg.user_must_be_an_email'));
        }
        r_snack_error.current.setOpen(true);
      }
    } else {
      // se guardó exitosamente
      storeSettSecUser.inUser = lastSaveRv.theValue;
      Promise.all([setStoreSettSecUser(storeSettSecUser)]).then((result) => {
        forceUIUpdate();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm
        moduleName={trans('field.user')}
        xref={r_form}
        url="sett/sec/users"
        filterIdField='inUser'
        filterIdValue={storeSettSecUser.inUser}
        onFormLoad={formLoad}
        onFormSave={isFullAccess() && formSave}
        onFormDelete={!isMaster && isFullAccess() && formDelete}
      >
        <CxHidden xref={useRef(null)} dbfield="n_user.inUser" value={storeSettSecUser.inUser || ''} />
        <CxHidden xref={useRef(null)} dbfield="n_user.txType" value={'E'} />

        <CxInput xref={rf_txUser} label={trans('field.user')} dbfield="n_user.txUser" lowerCase required maxLength={255} disabled={isMaster} /* onGetValue={getValueUser} */ />
        <CxInput xref={useRef(null)} label={trans('field.password')} dbfield="n_user.txPassword" lowerCase type="password" required maxLength={50} />

        <CxChooser xref={rf_txSecGroup}
          label={trans('field.group')}
          dbfield="n_sec_group.txSecGroup" dbfieldkey="n_user.inSecGroup"
          id="n_sec_group"
          table="n_sec_group"
          col_id="inSecGroup"
          col_tx="txSecGroup"
          readOnly={false}
          required
          disabled={isMaster}
        />

        <CxAccordion title={trans('field.options')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >

          <CxChooser xref={rf_txBranchForced}
            label={trans('field.forced_x_0', 'field.branch')}
            dbfield="s_app.txBranchForced" dbfieldkey="s_app.inBranchForced"
            id="n_branch"
            table="n_branch"
            col_id="inBranch"
            col_tx="txBranch"
            extra_filter_1={"boActive='1'"}
          />

          <CxState mode='checkbox' xref={rf_boShowUserDataOnly} 
            dbfield="s_app.boShowUserDataOnly"
            label={trans('field.sett_user_data_only')} 
          />

        </CxAccordion>

        <CxInput xref={useRef(null)} label={trans('field.notes')} dbfield="n_user.txNotes" minRows={4} />

      </GxForm>

      <CxSnackbar xref={r_snack_error} severity="error" value={r_error_message.current} />

    </div>
  );

}

export default MxSettSecUserForm;
